import React, { Component } from 'react';
import Label from './Label';
import './style.css';



const Selector = (props) => {
    return (
    <div className='select-group'>
    <div className='select-label'>
    <Label name="Pick a Classic" /> </div>
	<select className='selector' value={props.classic} onChange={props.onSelectorChangeNow}>
		<option value="Alice's Adventures in Wonderland">Alice's Adventures in Wonderland</option>
        <option value="Around the World in Eighty Days">Around the World in Eighty Days</option>
		<option value="Pride and Prejudice">Pride and Prejudice</option>
        <option value="The Invisible Man">The Invisible Man</option>
        <option value="Why Write the Classics">Why Write the Classics</option>
		</select>
    </div>
    );
}

export default Selector


// WEBPACK FOOTER //
// ./src/components/Selector.js